/** FormatDetail のバックアップ確認まわりの純関数・定数 */

const LAST_SAVE_DATE_SAVE_KEY = 'lastSaveDate'

/** 'yagiProfile' は端末ごとのため除外 */
export const BACKUP_KEYS_LIST = [
  'format_rirekisho',
  'format_shokumukeirekisho',
  'format_letter',
  'format_etc',
  'format_taishokutodoke',
  'format_english_resume',
  'basicData',
  'recentEdit',
  LAST_SAVE_DATE_SAVE_KEY
] as const

export const DOC_PAPER_HEIGHT_PX = 794

export type FormatDetailBackupPayload = Record<string, unknown> & {
  lastSaveDate?: string | Date
  format_rirekisho?: Record<string, unknown>
  format_shokumukeirekisho?: Record<string, unknown>
  format_letter?: Record<string, unknown>
  format_taishokutodoke?: Record<string, unknown>
  basicData?: Record<string, unknown>
}

export type FormattedBackupData = {
  lastSaveDate: string | Date | undefined
  label: string
  format_rirekisho: Record<string, unknown>
  format_shokumukeirekisho: Record<string, unknown>
  format_letter: Record<string, unknown>
  format_taishokutodoke: Record<string, unknown>
  basicData: Record<string, unknown>
  [key: string]: unknown
}

export function buildFormattedBackupData(
  latest: FormatDetailBackupPayload
): FormattedBackupData {
  return {
    lastSaveDate: latest.lastSaveDate,
    label: '保存データ',
    format_rirekisho: latest.format_rirekisho || {},
    format_shokumukeirekisho: latest.format_shokumukeirekisho || {},
    format_letter: latest.format_letter || {},
    format_taishokutodoke: latest.format_taishokutodoke || {},
    basicData: latest.basicData || {}
  }
}

export function expectedDocumentTypeForFormat(
  formatId: string | undefined
): 'shokumukeirekisho' | 'rirekisho' {
  if (
    formatId &&
    (formatId.includes('shokumukeirekisho') || formatId.includes('skillsheet'))
  ) {
    return 'shokumukeirekisho'
  }
  return 'rirekisho'
}
